import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";

import { FileUploader } from "ng2-file-upload";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { FileUploaderService } from "@app-services/file-uploader.service";
import { ValidatorForm } from "@app-shared/validators/validator-form";

@Component({
    selector: 'app-publication-attachment',
    templateUrl: './publication-attachment.component.html',
    styleUrls: ['./publication-attachment.component.scss'],
    standalone: false
})
export class PublicationAttachmentComponent implements OnInit, OnDestroy {
    
    @Input('requiredIndicator') public requiredIndicator: boolean = false;

    @Input('initialUrl') public initialUrl?: string;

    @Input('initialAttachmentUrl') public initialAttachmentUrl?: string;

    @Output('onUrlChange') public onUrlChange = new EventEmitter<string>();

    @Output('onFileChange') public onFileChange = new EventEmitter<File>();

    public readonly attachmentTypeControl = new UntypedFormControl(null);
    public readonly urlControl = new UntypedFormControl(null, [ValidatorForm.patternLink]);
    public readonly fileUrlControl = new UntypedFormControl(null);

    public isPdfAttachment: boolean = false;

    public readonly contentUploader: FileUploader;
	public hasBaseDropZoneOverContent = false;
    
    private readonly _unsubscribeAll = new Subject<void>();

    constructor(
        private readonly _fileUploaderService: FileUploaderService,
    ) {
        this.contentUploader = this._fileUploaderService.getInstances({
			autoUpload: false,
            url: ''
		});
    }

    ngOnInit(): void {
        if (this.initialUrl) {
            this.attachmentTypeControl.patchValue('URL');
            this.urlControl.patchValue(this.initialUrl);
        } else if (this.initialAttachmentUrl) {
            this.attachmentTypeControl.patchValue('FILE');
            this.fileUrlControl.patchValue(this.initialAttachmentUrl);
            this.isPdfAttachment = this._isPdfAttachment(this.initialAttachmentUrl);
        }

        this.urlControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll)
            )
            .subscribe((url: string) => {
                this.onUrlChange.emit(url);
            });

        this.contentUploader.onAfterAddingFile = (file) => {
            this.onFileChange.emit(file._file);
            const fileUrl = URL.createObjectURL(file._file);
            this.fileUrlControl.patchValue(fileUrl);
            this.isPdfAttachment = this._isPdfAttachment(fileUrl, file._file);
        }

        this.attachmentTypeControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.urlControl.patchValue(null);
                this.removeAttachment();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    public fileOverBaseContent(e: any): void {
		this.hasBaseDropZoneOverContent = e;
	}

    public removeAttachment(): void {
        this.fileUrlControl.patchValue(null);
        this.onFileChange.emit(null);
    }

    private _isPdfAttachment(url: string, file?: File): boolean {
        if (file) {
            return file.type === 'application/pdf';
        }
        return url.endsWith('.pdf');
    }
}